import React, { createContext, useContext } from "react"

import type { PlanLessonController } from "./PlanLessonTypes"

const PlanLessonLocalContext = createContext<PlanLessonController | null>(null)

interface PlanLessonLocalProviderProps {
  value: PlanLessonController
  children: React.ReactNode
}

export const PlanLessonLocalProvider = ({
  value,
  children,
}: PlanLessonLocalProviderProps) => {
  return (
    <PlanLessonLocalContext.Provider value={value}>
      {children}
    </PlanLessonLocalContext.Provider>
  )
}

export function usePlanLessonLocal(): PlanLessonController {
  const context = useContext(PlanLessonLocalContext)

  if (!context) {
    throw new Error("PlanLesson local context is missing")
  }

  return context
}
